<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div no-body class="mb-1" style="width: 100%; position: relative;" ref="selectTratamientos" v-b-tooltip.hover.topleft.v-light :title="!mostrarKits ? tratamiento.nombreTratamiento : tratamiento.nombreKit">
            <div class="scrollable-container-tratamientos barras d-flex " style="margin-top: 10px;">
              <span v-if="tratamiento.idKit !== null && tratamiento.idKit !== undefined" class="text-left"><b-badge pill variant="success">KIT</b-badge></span>
              <b-form-input class="input-filter" v-model="tratamiento.nombreTratamiento" @click="toggleCollapse" placeholder="Selecciona un tratamiento" type="text" @input="!mostrarKits ? buscarTratamiento() : buscarKit()" @keydown.enter.prevent="!mostrarKits ? buscarTratamiento() : buscarKit()">
              </b-form-input>
              <b-icon @click="limpiarTratamiento()" class="mr-2" variant="lg" font-scale="1.2" v-if="!tratamiento.collapseOpen && !mostrarKits" icon="x" :rotate="tratamiento.collapseOpen ? 180 : 0"></b-icon>
              <b-icon icon="chevron-down" font-scale="1.1" :rotate="tratamiento.collapseOpen ? 180 : 0" @click="toggleCollapse"></b-icon>
            </div>
            <b-collapse class="floating-collapse text-left" :id="indexPadecimiento+'opcion-'+indexOpcion+' tratamiento-' + i" v-model="tratamiento.collapseOpen"
                        accordion="my123-accordion" role="tab123panel" style="border: 1px solid #D0D0D0; background-color: white; position: absolute; left: 0; width: 100%; height: 100%;"
                        ref="select-collap"
            >
                <b-form-checkbox v-if="kits" switch v-model="mostrarKits" class="ml-0 pl-0 pr-5 mt-2">Kits dentales</b-form-checkbox>
                <span v-if="mostrarKits" class="ml-3" style="color: var(--color-dentalia-v2); font-weight: bold;">Lista de kits dentalia</span>
                <ul v-if="mostrarKits" id="myUL" style="margin-left: 0px; overflow-y: scroll; padding-left: 15px;" :style="resultadosBusquedaFiltroKits.length > 8 ? 'height: 15em;' : 'height: auto;'">
                    <Kits :idSeleccionado="idSeleccionado" v-for="(itemKit, indexKit) in resultadosBusquedaFiltroKits" :key="indexKit" :itemKit="itemKit" :indexKit="indexKit" @seleccionarKit="seleccionarKit" :indexPadecimiento="indexPadecimiento" :indexOpcion="indexOpcion" :i="i"/>
                </ul>
                <ul v-if="!mostrarKits" id="myUL" style="margin-left: 0px; overflow-y: scroll; padding-left: 15px;" :style="resultadosBusquedaFiltro.length > 8 ? 'height: 15em;' : 'height: auto;'">
                    <TreeItem :idSeleccionado="idSeleccionado" v-for="(item, index) in resultadosBusquedaFiltro" :key="index" :item="item" @seleccionarTratamiento="seleccionarTratamiento" />
                </ul>
              
            </b-collapse>
          </div>
    </div>
  </template>
  
<script>
    import TreeItem from './TreeItem.vue';
    import Kits from './Kits.vue';
    export default {
        name: "SelectTratamientos",
        components: {
            TreeItem,
            Kits,
        },
        props: {
            indexPadecimiento: Number,
            indexOpcion: Number,
            catalogoTratamientos: Array,
            idSeleccionado: {
                type: Number,
                default: null
            },
            tratamiento: null,
            tratamientos: Array,
            i:Number,

            kits: {
                type: Boolean,
                default: false
            },
            catalogokits: Array,
        },
        data() {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
                catalogoTratamientosOrdenado: [],
                tratamientosConHijos: [],
                tratamientosOrganizados: null,
                mostrarKits: false,
            };
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleClickOutside);
        },
        validations: {},
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.organizarTratamientos();
        },
        watch: {},
        computed: {},
        methods: {
            toggleCollapse(event) {
                event.stopPropagation();
                this.tratamiento.collapseOpen = !this.tratamiento.collapseOpen;
            },
            handleClickOutside(event) {
                const domNode = this.$refs.selectTratamientos;
                if (!domNode || !domNode.contains(event.target)) {
                    this.tratamiento.collapseOpen = false;
                }
            },
            limpiarTratamiento(){
                this.tratamiento.nombreTratamiento = "";
                this.tratamiento.idTratamiento = null;
                this.tratamiento.precio = null;
            },

            seleccionarTratamiento(data){
                if(data != null){
                    this.tratamiento.nombreTratamiento = data.nombre;
                    this.tratamiento.idTratamiento = data.idTratamiento;
                    this.tratamiento.precio = data.precio;
                    this.tratamiento.idKit = null;
                    this.tratamiento.listaTratamientos = [];
                    this.tratamiento.argumentarioCompleto = data.argumentarioCompleto;
                }
                this.closeCollapse();
            },

            seleccionarKit(data){
                if(data != null){
                    this.tratamiento.nombreTratamiento = data.nombreKit;
                    this.tratamiento.nombreKit = data.nombreKit;
                    this.tratamiento.idKit = data.idKit;
                    this.tratamiento.listaTratamientos = data.listaTratamientos;
                    this.tratamiento.idTratamiento = null;
                    this.tratamiento.opcion = this.indexOpcion + 1;
                    let precioTotal = 0;
                    this.tratamiento.listaTratamientos.forEach(lt => {
                        precioTotal = precioTotal + lt.precio;
                    });
                    this.tratamiento.precio = precioTotal;
                    this.tratamiento.argumentarioCompleto = data.argumentarioCompleto;
                }
                this.closeCollapse();
            },

            openCollapse() {
                this.tratamiento.collapseOpen = true;
            },
            closeCollapse(){
                this.tratamiento.collapseOpen = false;
            },

            buscarTratamiento() {
                this.tratamiento.collapseOpen = false;
                this.resultadosBusquedaFiltro = this.buscar(this.tratamientosOrganizados)
                this.tratamiento.collapseOpen = true;
            },

            buscarKit() {
                this.tratamiento.collapseOpen = false;
                this.resultadosBusquedaFiltroKits = this.buscar(this.kitsOrganizados)
                this.tratamiento.collapseOpen = true;
            },

            buscar(tratamiento) {
                if(!this.mostrarKits){
                    return tratamiento.filter(p => {
                        if (p.nombre.toLowerCase().includes(this.tratamiento.nombreTratamiento.toLowerCase().trim())){
                            return true;
                        }
                    })
                }else{
                    return tratamiento.filter(p => {
                        if (p.nombreKit.toLowerCase().includes(this.tratamiento.nombreTratamiento.toLowerCase().trim())){
                            return true;
                        }
                    })
                }
            },
            
            organizarTratamientos() {
                this.kitsOrganizados = this.catalogokits;
                this.resultadosBusquedaFiltroKits = this.kitsOrganizados;
                
                this.tratamientosOrganizados = this.catalogoTratamientos
                this.resultadosBusquedaFiltro = this.tratamientosOrganizados
            }
        },
    };
</script>
  
<style scoped>
    p {
        color: #6f6f6f;
    }
    .floating-collapse {
        border-radius: 5px;
        z-index: 1000; 
    }
    .barras {
        border-width: 1px;
        border-style: solid;
        border-color: #d1d0d0;
        background: #ffffff;
        margin-top: 20px;
        padding-right: 1%;
        padding-left: 1%;
        border-radius: 5px;
        text-align: left;
        align-items: center;
    }

    .scrollable-container-tratamientos {
        overflow-y: auto;
        max-height: 105px;
    }
</style>
  
